const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  lineNotifyStatus ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/linepush/line-notify-status', { params })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
